import { render, staticRenderFns } from "./DialogEditAssociateProfile.vue?vue&type=template&id=5bdbd7bf&scoped=true&"
import script from "./DialogEditAssociateProfile.vue?vue&type=script&lang=ts&"
export * from "./DialogEditAssociateProfile.vue?vue&type=script&lang=ts&"
import style0 from "./DialogEditAssociateProfile.vue?vue&type=style&index=0&id=5bdbd7bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdbd7bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCol,VForm,VRow,VTextField})
